import React, { useEffect, useContext } from 'react';

import ResultsComponent from '../../../../components/ResultsComponent';

import { InfusionPerTimeContext } from '../../../../contexts/InfusionProvider/InfusionPerTimeProvider';
import { CalculatorNavigationContext } from '../../../../contexts/CalculatorNavigationProvider';
import { ResultsContext } from '../../../../contexts/ResultsProvider';

function InfusionPerTimeResultScreen(): React.ReactElement {
 const {
  setNextButtonAction,
  setNextButtonText,
  setBackButtonText,
  setBackButtonAction,
 } = useContext(CalculatorNavigationContext);

 const { thirdScreenRedirect, homeRedirect } = useContext(
  InfusionPerTimeContext,
 );

 const { setHasMultipleResults, setResultArray } = useContext(ResultsContext);

 const setResultProps = () => {
  setHasMultipleResults(true);
  setResultArray([
   { description: 'Hastighet' },
   { description: 'Hastighet' },
   { description: 'Hastighet' },
   { description: 'Hastighet' },
  ]);
 };

 const setNavigationProps = () => {
  const setNextButtonProps = () => {
   setNextButtonAction(homeRedirect); // fix
   setNextButtonText('Ferdig');
  };
  const setBackButtonProps = () => {
   setBackButtonText('Forrige');
   setBackButtonAction(thirdScreenRedirect);
  };
  setNextButtonProps();
  setBackButtonProps();
 };

 useEffect(() => {
  setNavigationProps();
  setResultProps();
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, []);

 return <ResultsComponent />;
}

export default InfusionPerTimeResultScreen;
